/* istanbul ignore file */
import React from 'react';
import NameDescriptionInput from 'domain/recruiting/vacancy/shared/input/NameDescriptionInput';

interface VacancyPersonalityInputProps {
  source: string;
}

const VacancyPersonalityInput = ({ source, ...props }: VacancyPersonalityInputProps) => {
  return <NameDescriptionInput nameLabel="Responsibility" source={source} {...props} />;
};

export default VacancyPersonalityInput;
